export const useIsMobile = (): boolean => inject<boolean>('isMobile') || false;

export default useIsMobile;
